var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons industries"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_94",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#3470E4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "medication",
    d: "M18 29.1667H23V25H27.1667V20H23V15.8333H18V20H13.8334V25H18V29.1667ZM12.1667 35C11.25 35 10.4653 34.6736 9.81254 34.0208C9.15976 33.3681 8.83337 32.5833 8.83337 31.6667V13.3333C8.83337 12.4167 9.15976 11.6319 9.81254 10.9792C10.4653 10.3264 11.25 10 12.1667 10H28.8334C29.75 10 30.5348 10.3264 31.1875 10.9792C31.8403 11.6319 32.1667 12.4167 32.1667 13.3333V31.6667C32.1667 32.5833 31.8403 33.3681 31.1875 34.0208C30.5348 34.6736 29.75 35 28.8334 35H12.1667ZM12.1667 31.6667H28.8334V13.3333H12.1667V31.6667ZM10.5 8.33333V5H30.5V8.33333H10.5Z",
    fill: "#5D8DE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharma);
export default __webpack_public_path__ + "static/media/Pharma.f5294525838f6f51aacf76db165d3037.svg";
export { ForwardRef as ReactComponent };